import { useState } from "react";

const useDisabledFields = (initialDisabled = {}) => {
    const [disabledFields, setDisabledFields] = useState(initialDisabled);

    const disableField   = (name) => setDisabledFields(prev => ({ ...prev, [name]: true }));
    const enableField    = (name) => setDisabledFields(prev => ({ ...prev, [name]: false }));
    const toggleField    = (name) => setDisabledFields(prev => ({ ...prev, [name]: !prev[name] }));
    const isFieldDisabled = (name) => !!disabledFields[name];

    return { disableField, enableField, toggleField, isFieldDisabled };
};

export default useDisabledFields;
